// Investment Payment
export const PLATFORM_FEE = 0
export const PLATFORM_FEE_CURRENCY = 'USD'

/** Toggle when promo validation API is ready */
export const ENABLE_PAYMENT_PROMO_CODE = false
